import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PLATFORM_ADMIN_HOME } from '../platform-admin/staffConsolePaths';

/**
 * 包住实验室租户 Shell（侧栏 + 顶栏）。超级管理员应使用平台管理后台，禁止从租户 UI 做日常操作。
 */
const TenantShellGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { token, role } = useAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  if (role === '超级管理员') {
    return <Navigate to={PLATFORM_ADMIN_HOME} replace />;
  }
  if (role === '商家') {
    return <Navigate to="/merchant/orders" replace />;
  }
  return <>{children}</>;
};

export default TenantShellGuard;
